export enum Events {
    CONNECTED = 'connected',
    DURATION = 'duration',
    ERROR = 'error',
    PROCESS_NEXT_ITEM_COMPLETED = 'process_next_item_completed',
    START_SEEK_MEDIA_SERVER_PROCESSING = 'start_seek_media_server_processing',
}
